<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <v-card>
        <v-alert v-if="error" tile type="error">{{ error }}</v-alert>

        <v-card-title class="primary white--text">
          {{ formTitle }}
        </v-card-title>

        <v-card-text class="mt-5 pt-5">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="editedItem.name"
                  :counter="255"
                  :rules="[rules.required, rules.maxLength(255)]"
                  v-bind:label="$tc('label.name', 1)"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-autocomplete
                  :items="tenants.edges"
                  :loading="$apollo.queries.tenants.loading"
                  :rules="[rules.required]"
                  clearable
                  item-text="node.tenantName"
                  item-value="node.id"
                  multiple
                  outlined
                  v-bind:label="$tc('label.tenant', 2)"
                  v-model="editedItem.tenants"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-5 pr-5">
          <v-spacer></v-spacer>
          <v-btn :disabled="isSaving" text rounded @click="close">{{
            $t("button.cancelBtn")
          }}</v-btn>
          <v-btn
            outlined
            rounded
            :loading="isSaving"
            color="primary"
            @click="save"
            >{{ $t("button.saveBtn") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";

export default {
  name: "partner-edit-dialog",
  props: ["dialog", "object"],
  components: {},

  apollo: {
    tenants: {
      query: gql`
        query tenants {
          tenants(orderBy: ["tenantName"]) {
            edges {
              node {
                id
                tenantName
              }
            }
          }
        }
      `,
      variables() {},
      fetchPolicy: "cache-and-network",
      update: (data) => data.tenants,
      skip: true,
    },
  },

  data() {
    return {
      error: null,
      isSaving: false,

      tenants: {},

      editedItem: {
        id: null,
        name: null,
        tenants: [],
      },
      defaultItem: {
        id: null,
        name: null,
        tenants: [],
      },
      rules: {
        required: (v) => !helper.isEmpty(v) || "This field is required",
        minLength: (len) => (v) =>
          (v || "").length >= len ||
          `Invalid character length, required ${len}`,
        maxLength: (len) => (v) =>
          (v || "").length <= len || "Invalid character length, too long",
      },
    };
  },
  computed: {
    formTitle() {
      return this.object ? this.$t("label.edit") : this.$t("label.add");
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$apollo.queries.tenants.skip = false;
      }

      this.resetForm();
    },
  },
  created() {},
  methods: {
    resetForm() {
      this.error = null;
      this.isSaving = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      if (this.dialog && this.object) {
        this.editedItem.id = this.object.id;
        this.editedItem.name = this.object.name;
        this.editedItem.tenants = this.object.tenants
					? this.object.tenants.edges.map((item) => {
							return item.node.id;
					  })
					: [];
      } else {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      }
    },

    close() {
      this.$emit("update:dialog", false);
      this.resetForm();
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // set form state
      this.error = null;
      this.isSaving = true;

      // prepare api call payload
      var payload = {
        name: this.editedItem.name,
        tenants: this.editedItem.tenants,
      };

      if (this.object) {
        payload.id = this.editedItem.id;

        this.$apollo
          .mutate({
            mutation: gql`
              mutation updatePartner($input: UpdatePartnerInput!) {
                updatePartner(input: $input) {
                  partner {
                    id
                  }
                }
              }
            `,
            variables: {
              input: payload,
            },
          })
          .then((response) => {
            this.$emit("changed", response);
            this.close();

            const payload = {
              color: "success",
              message: `Partner successfully edited`,
            };
            this.$store.dispatch("snackbar/showMessage", payload);
          })
          .catch((error) => {
            console.log(error);

            this.error = error.graphQLErrors
              .map((error) => error.message)
              .join(", ");
          })
          .finally(() => {
            this.isSaving = false;
          });
      } else {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation createPartner($input: CreatePartnerInput!) {
                createPartner(input: $input) {
                  partner {
                    id
                  }
                }
              }
            `,
            variables: {
              input: payload,
            },
          })
          .then((response) => {
            this.$emit("changed", response);
            this.close();

            const payload = {
              color: "success",
              message: `Partner successfully added`,
            };
            this.$store.dispatch("snackbar/showMessage", payload);
          })
          .catch((error) => {
            console.log(error);

            this.error = error.graphQLErrors
              .map((error) => error.message)
              .join(", ");
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>
